// Recovered compiled webpack factory 86542. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      getRedirectError: function () {
        return i;
      },
      getRedirectStatusCodeFromError: function () {
        return f;
      },
      getRedirectTypeFromError: function () {
        return c;
      },
      getURLFromRedirectError: function () {
        return u;
      },
      permanentRedirect: function () {
        return l;
      },
      redirect: function () {
        return s;
      },
    }));
  let n = r(81099),
    a = r(86437),
    o = void 0;
  function i(e, t, r) {
    void 0 === r && (r = n.RedirectStatusCode.TemporaryRedirect);
    let o = Object.defineProperty(Error(a.REDIRECT_ERROR_CODE), "__NEXT_ERROR_CODE", {
      value: "E394",
      enumerable: !1,
      configurable: !0,
    });
    return ((o.digest = a.REDIRECT_ERROR_CODE + ";" + t + ";" + e + ";" + r + ";"), o);
  }
  function s(e, t) {
    var r;
    throw (
      null != t ||
        (t = (null == o || null == (r = o.getStore()) ? void 0 : r.isAction)
          ? a.RedirectType.push
          : a.RedirectType.replace),
      i(e, t, n.RedirectStatusCode.TemporaryRedirect)
    );
  }
  function l(e, t) {
    throw (
      void 0 === t && (t = a.RedirectType.replace),
      i(e, t, n.RedirectStatusCode.PermanentRedirect)
    );
  }
  function u(e) {
    return (0, a.isRedirectError)(e) ? e.digest.split(";").slice(2, -2).join(";") : null;
  }
  function c(e) {
    if (!(0, a.isRedirectError)(e))
      throw Object.defineProperty(Error("Not a redirect error"), "__NEXT_ERROR_CODE", {
        value: "E260",
        enumerable: !1,
        configurable: !0,
      });
    return e.digest.split(";", 2)[1];
  }
  function f(e) {
    if (!(0, a.isRedirectError)(e))
      throw Object.defineProperty(Error("Not a redirect error"), "__NEXT_ERROR_CODE", {
        value: "E260",
        enumerable: !1,
        configurable: !0,
      });
    return Number(e.digest.split(";").at(-2));
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
